module.exports = __webpack_public_path__ + "static/media/icon-login.72c59197.svg";